import { EnvelopeSimple, Lightning } from '@phosphor-icons/react';
import { Text } from '@typedream/ui';
import IconPopup from '../IconPopup';

interface BlockCreateEmailModalProps {
  isShow: boolean;
  setIsShow: React.Dispatch<React.SetStateAction<boolean>>;
}

function BlockCreateEmailModal({ isShow, setIsShow }: BlockCreateEmailModalProps) {
  return (
    <IconPopup
      Icon={EnvelopeSimple}
      width={536}
      height="auto"
      open={isShow}
      setopen={setIsShow}
      showCloseButton={false}
      title="Upgrade to Launch Plan to start sending emails"
      button={{
        leftIcon: <Lightning weight="fill" size={16} />,
        children: 'Upgrade plan',
        className: 'w-full',
      }}
    >
      <Text as="p" variant="mute" className="mt-2 mb-9">
        By upgrading to our Launch Plan, you can send emails to your audience
      </Text>
    </IconPopup>
  );
}

export default BlockCreateEmailModal;
